<template>
  <div class="col-12 px-5">
    <!-- <h6 class="pl-4 text-blue mb-8">รายละเอียดสัญญาเลขที่ {{ showData.agreementNo }}</h6> -->
    <v-layout column>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-0`" row>
        <div class="col-6 px-0">{{ mapWord['agreementNo'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.agreementNo, 'agreementNo') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-1`" row>
        <div class="col-6 px-0">{{ mapWord['model'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.model, 'model') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-0`" row>
        <div class="col-6 px-0">{{ mapWord['netFinance'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.netFinance, 'netFinance') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-1`" row>
        <div class="col-6 px-0">{{ mapWord['installmentAmount'] }}</div>
        <div class="col-6 px-0">
          {{ checkData(showData.installmentAmount, 'installmentAmount') }}
        </div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-0`" row>
        <div class="col-6 px-0">{{ mapWord['dueDate'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.dueDate, 'dueDate') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-1`" row>
        <div :style="`color: ${color} !important`" class="col-6 px-0 font-weight-bold">
          {{ mapWord['osBalance'] }}
        </div>
        <div :style="`color: ${color} !important`" class="col-6 px-0 font-weight-bold">
          {{ checkData(showData.osBalance, 'osBalance') }}
        </div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-0`" row>
        <div class="col-6 px-0">{{ mapWord['lastDueDate'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.lastDueDate, 'lastDueDate') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-1`" row>
        <div class="col-6 px-0">{{ mapWord['suspensionTenor'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.suspensionTenor, 'suspensionTenor') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-0`" row>
        <div class="col-6 px-0">{{ mapWord['contractStatus'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.contractStatus, 'contractStatus') }}</div>
      </v-layout>
    </v-layout>
    <div class="py-4"></div>
    <v-layout column>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-0`" row>
        <div class="col-6 px-0">{{ mapWord['periodDue'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.periodDue, 'periodDue') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-1`" row>
        <div class="col-6 px-0">{{ mapWord['collectionAmount'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.collectionAmount, 'collectionAmount') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-0`" row>
        <div class="col-6 px-0">{{ mapWord['penaltyAmount'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.penaltyAmount, 'penaltyAmount') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-1`" row>
        <div class="col-6 px-0">{{ mapWord['otherFee'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.otherFee, 'otherFee') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-0`" row>
        <div class="col-6 px-0">{{ mapWord['discountAmount'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.discountAmount, 'discountAmount') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-1`" row>
        <div class="col-6 px-0">{{ mapWord['odAmount'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.odAmount, 'odAmount') }}</div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-0`" row>
        <div class="col-6 px-0">{{ mapWord['currentInstallment'] }}</div>
        <div class="col-6 px-0">
          {{ checkData(showData.currentInstallment, 'currentInstallment') }}
        </div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-1`" row>
        <div :style="`color: ${color} !important`" class="col-6 px-0 font-weight-bold">
          {{ mapWord['paymentDue'] }}
        </div>
        <div :style="`color: ${color} !important`" class="col-6 px-0 font-weight-bold">
          {{ checkData(showData.paymentDue, 'paymentDue') }}
        </div>
      </v-layout>
      <v-layout :class="`py-2 px-3 m-0 col-12 table-index-0`" row>
        <div class="col-6 px-0">{{ mapWord['payDueDate'] }}</div>
        <div class="col-6 px-0">{{ checkData(showData.payDueDate, 'payDueDate') }}</div>
      </v-layout>
    </v-layout>
    <div class="py-3"></div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    showData: {
      default: {}
    },
    color: {
      default: '#23409a'
    }
  },
  data() {
    return {
      mapWord: {
        agreementNo: 'เลขที่สัญญา',
        model: 'ยี่ห้อ/รุ่น',
        netFinance: 'ค่างวดทั้งหมด(บาท)',
        installmentAmount: 'ผ่อนงวดละ(บาท)',
        dueDate: 'กำหนดชำระทุกวันที่',
        lastDueDate: 'วันที่ครบกำหนดงวดสุดท้าย',
        osBalance: 'ค่างวดคงเหลือ',
        periodDue: 'งวดปัจจุบัน/ทั้งหมด',
        collectionAmount: 'ค่าธรรมเนียมติดตาม(บาท)',
        penaltyAmount: 'ค่าธรรมเนียมชำระล่าช้า(บาท)',
        otherFee: 'ค่าธรรมเนียมอื่นๆ(บาท) ',
        paymentDue: 'ยอดรวมที่ต้องชำระ(บาท)',
        payDueDate: 'ชำระภายในวันที่',
        odPeriodDue: 'งวดที่ค้างชำระ',
        odAmount: 'ค่างวดค้างชำระ',
        isPastDue: 'สถานะเกินกำหนด',
        contractStatus: 'สถานะสัญญา',
        currentInstallment: 'ค่างวดเดือนนี้(บาท)',
        discountAmount: 'เงินส่วนลด(บาท)',
        suspensionTenor: 'ขยายอายุสัญญาจากพักชำระหนี้'
      }
    }
  },
  mounted() {},
  computed: {},
  methods: {
    checkData(input, name) {
      if (name == 'lastDueDate' || name == 'payDueDate') {
        const dateYear = moment(input).format('YYYY')
        const dateText = moment(input).format('DD/MM/YYYY') || '-'
        if (dateYear == '1753') {
          return '-'
        } else {
          return dateText
        }
      } else {
        if (typeof input == 'number') {
          var pattern = /\d{1,3}(?=(\d{3})+(?!\d))/g
          let fl_text = parseFloat(input).toFixed(2)
          return fl_text.toString().replace(pattern, '$&,')
        } else {
          return input || '-'
        }
      }
    }
  }
}
</script>

<style>
.table-index-0 {
  background-color: #f0f0f0;
}
.table-index-1 {
  background-color: #d8d8d8;
}
</style>
